// 合同对比页面
<template>
  <div class="root-contrast">
    <!-- title -->
    <route-name propsRouteName="智能文档比对"></route-name>
    <!-- content 内容 -->
    <div class="content">
      <div class="contract">
        <!-- 原始文件 -->
        <div>
          <p style="color: #222">1.上传原文件/合同模板：</p>
          <div class="upload">
            <img
              src="/images/AISmart/icon/group.png"
              width="49px"
              height="47px"
              alt=""
            />
            <el-upload
              ref="originUpload"
              class="upload-bth"
              action="#"
              :limit="1"
              :auto-upload="false"
              :on-exceed="exceed"
              :accept="acceptType"
              :on-change="changeOrigin"
              :before-upload="originFileBeforeUpload"
            >
              <el-button size="small" type="danger" plain>选择文件</el-button>
            </el-upload>
            <span style="color: #999"
              >可支持
              {{ acceptType }} 格式文件，<br />上传单个文件大小不超过30M。</span
            >
          </div>
          <div class="ignore-box">
            <p>
              对比规则设置：
              <el-checkbox
                :true-label="1"
                :false-label="0"
                v-model="ignoreCheck"
                >忽略标点符号</el-checkbox
              >
            </p>
          </div>
        </div>
        <!-- 对比文件 -->
        <div>
          <p style="color: #222">2. 上传第二文件/比对合同：</p>
          <div class="upload">
            <img
              src="/images/AISmart/icon/group.png"
              width="49px"
              height="47px"
              alt=""
            />
            <el-upload
              class="upload-bth"
              action="#"
              ref="targetUpload"
              :limit="1"
              :auto-upload="false"
              :on-exceed="exceed"
              :accept="acceptType"
              :on-change="changeTarget"
              :before-upload="targetFileChange"
            >
              <el-button size="small" type="danger" plain>选择文件</el-button>
            </el-upload>
            <span style="color: #999"
              >可支持
              {{ acceptType }} 格式文件，<br />上传单个文件大小不超过30M。</span
            >
          </div>
        </div>
      </div>
      <div class="bontrast-btn">
        <el-button type="danger" :loading="loading" @click="docContrast"
          >开始对比</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import RouteName from "@/components/route-name";
import {
  ApiMethods,
  postFileTempUpload
} from "../../../assets/js/http-serve/http-methods";
import { isInDingTalk } from "@/assets/js/utils/ding-env";

export default {
  data () {
    return {
      smartAPI: ApiMethods.AIDocSmart,
      acceptType: ".pdf,.doc,.docx,.xls,.xlsx,.pptx,.ppt",
      loading: false,
      originFile: [],
      targetFile: [],
      // 是否忽略标点
      ignoreCheck: 0
    };
  },
  // data end
  methods: {
    exceed (file, fileList) {
      this.$message.error("仅支持单文件上传,请删除后重新上传");
    },
    // 原文件上传
    originFileBeforeUpload (file) {
      postFileTempUpload({ file, fileType: 1 })
        .then(data => {
          this.originFile = [];
          this.originFile.push(data);
        })
        .catch(err => {
          this.$message.warning(err.description || "上传文件失败");
        });
    },
    changeOrigin (file, fileList) {
      if (file.status === "ready") {
        const re = new RegExp("(.pdf|.doc|.docx|.xls|.xlsx|.pptx|.ppt)$", "i"),
          isLt30M = file.size / 1024 / 1024 < 30;
        if (!isLt30M) {
          this.$message.error("上传文件大小不能超过 30MB!");
          return false;
        }
        if (!re.test(file.name)) {
          this.$message.error(
            "文件格式只能是 pdf / doc / docx / xls / xlsx 文件"
          );
          return false;
        }
        this.$refs.originUpload.submit();
      }
    },
    changeTarget (file, fileList) {
      if (file.status === "ready") {
        const re = new RegExp("(.pdf|.doc|.docx|.xls|.xlsx|.pptx|.ppt)$", "i"),
          isLt30M = file.size / 1024 / 1024 < 30;
        if (!isLt30M) {
          this.$message.error("上传文件大小不能超过 30MB!");
          return false;
        }
        if (!re.test(file.name)) {
          this.$message.error(
            "文件格式只能是 pdf / doc / docx / xls / xlsx 文件"
          );
          return false;
        }
        this.$refs.targetUpload.submit();
      }
    },
    // 对比文件上传
    targetFileChange (file) {
      postFileTempUpload({ file, fileType: 1 })
        .then(data => {
          this.targetFile = [];
          this.targetFile.push(data);
        })
        .catch(err => {
          this.$message.warning(err.description || "上传文件失败");
        });
    },
    // 开始对比
    async docContrast () {
      let { originFile, targetFile } = this,
        FD = new FormData();
      if (originFile.length === 0)
        return this.$message.error("请上传符合条件的原文件/合同模板");
      if (targetFile.length === 0)
        return this.$message.error("请上传符合条件的第二文件/比对合同");
      this.loading = true;
      FD.append("originStoreId", originFile[0].targetId);
      FD.append("originFileType", targetFile[0].fileType);
      FD.append("targetStoreId", targetFile[0].targetId);
      FD.append("targetFileType", targetFile[0].fileType);
      FD.append("ignorePunctuations", this.ignoreCheck);
      this.smartAPI
        .Compare(FD)
        .then(res => {
          if (res.success) {
            this.originFile = [];
            this.targetFile = [];
            this.$router.push("/smartDoc/docContrast/contrastList");
          } else {
            if (res.code == 10807) {
              this.buyDia();
              return;
            }
            this.$message.error(res.description);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 显示购买弹窗
    buyDia () {
      this.$confirm("当前无文档比对功能使用次数，请前往购买！", "提示", {
        type: "error"
      })
        .then(res => {
          const url = this.globalConfig.domain.accountWeb + "/asset/aiContractChargePage"
          isInDingTalk ? location.href = url : window.open(url);
        })
        .catch(err => {
          // this.$message.error("err", err);
        });
    }
  },
  // methods end
  components: { RouteName }
};
</script>

<style scoped lang="less">
.root-contrast {
  height: 100%;
  background-color: #fff;
  .content {
    height: calc(85vh - 36px);
    padding: 16px;
    overflow: auto;
    .contract {
      margin-top: 30px;
      display: flex;
      justify-content: space-around;
      > div {
        // width: 495px;
        height: 238px;
        padding: 10px 10px 0 24px;
        background-color: #efefef;
        border-radius: 2px 2px 2px 2px;
        word-wrap: break-word;
        > p {
          margin-bottom: 15px;
        }
        .upload {
          // width: 450px;
          min-height: 182px;
          display: flex;
          padding: 5px;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          background: #ffffff;
          border-radius: 2px 2px 2px 2px;
          border: 1px solid #d9d9d9;
          .upload-bth {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
          }
        }
      }
    }
    .bontrast-btn {
      margin-top: 26px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .ignore-box {
      margin: 20px 0 10px -24px;
    }
  }
}
/deep/.el-upload-list__item-name {
  width: 15vw;
}
</style>



// WEBPACK FOOTER //
// pages/smartDoc/docContrast/contrast.vue